import { useTranslation } from 'react-i18next';
import { DatePicker, Form, Input } from 'antd';
import { CurrencyBadge } from '@/components/currency-badge';
import { formValidateAndSetNumber } from '@/utils/inputApi';

export default function VariationsInputSection({
  form,
  title,
  types,
  currency,
  baseName,
  disabled = false,
  showDates = false,
}) {
  const { t } = useTranslation(['forms']);

  if (!types || types.length === 0) {
    return null;
  }

  return (
    <div className="mt-4 rounded border bg-zinc-50 p-4">
      <div className="mb-3 flex items-center justify-between">
        <p className="font-medium text-gray-700">{title}</p>
        {currency && (
          <CurrencyBadge
            currency={currency.label}
            currencyCode={currency.currencyCode}
          />
        )}
      </div>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3">
        {types.map((type) => (
          <div key={type.key}>
            <Form.Item
              name={['otherAllowances', baseName, type.key]}
              label={type.label}
              className="!mb-0"
              labelCol={{
                className: '!pb-0 !h-[20px] [&_label]:!text-[13px]',
              }}
            >
              <Input
                min={0}
                type="number"
                step="any"
                size="small"
                className="h-8"
                placeholder={type.label}
                onChange={(e) =>
                  formValidateAndSetNumber(
                    form,
                    e,
                    ['otherAllowances', baseName, type.key],
                    0
                  )
                }
                disabled={disabled}
              />
            </Form.Item>
            {showDates && (
              <div className="mt-1 flex gap-2">
                <Form.Item
                  name={[
                    'otherAllowances',
                    'suspensionVariationsDates',
                    type.key,
                    'validFrom',
                  ]}
                  className="!mb-0 flex-1"
                >
                  <DatePicker
                    picker="month"
                    format="MM/YYYY"
                    size="small"
                    className="w-full"
                    placeholder={t('validFrom', { ns: 'forms' })}
                    disabled={disabled}
                  />
                </Form.Item>
                <Form.Item
                  name={[
                    'otherAllowances',
                    'suspensionVariationsDates',
                    type.key,
                    'validTo',
                  ]}
                  className="!mb-0 flex-1"
                >
                  <DatePicker
                    picker="month"
                    format="MM/YYYY"
                    size="small"
                    className="w-full"
                    placeholder={t('validTo', { ns: 'forms' })}
                    disabled={disabled}
                  />
                </Form.Item>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
